// extracted by mini-css-extract-plugin
export default {"album":"Album_album__F4FFO","player":"Album_player__BbOu3"};